import React from "react";
import { Link } from "react-router-dom";
import PrivacyPage from "../../container/PrivacyPolicy";

const Footer = () => {

   return (
      <>
         <div className="footer">
            <div className="container inner-container">
               <div className="row">
                  <div className="col-md-3">
                     <h4>First Light Adventures</h4>
                     <p>The Himalayas offer an extraordinary world of natural wonders. From iconic mountains to tranquil lakes, the region offers something for everyone. Each adventure provides an unforgettable connection with nature and the traveller. In the Himalayas we embark on journeys that promise lasting memories and a deep sense of fulfilment. </p>
                  </div>

                  <div className="col-sm-6 col-md-3">
                     <h5>Pages</h5>
                     <ul>
                        <li><Link to="/"> Home </Link></li>
                        <li><Link to="/about"> About </Link> </li>
                        <li> <Link to="/explore/expeditions"> Expeditions </Link></li>
                        <li><Link to="/explore/experiences"> Experiences </Link> </li>
                        <li><Link to="/contact"> Contact</Link> </li>
                     </ul>
                  </div>

                  <div className="col-sm-6 col-md-3">
                     <h5>Terms & Policies</h5>
                     <ul>
                        <li><Link to="/cms/privacy"> Privacy Policy </Link></li>
                        <li><Link to="/cms/terms-and-conditions"> Terms and Conditions </Link></li>
                        {/* <li><Link to="/blog"> Blog </Link></li> */}
                     </ul>
                  </div>

                  <div className="col-md-3">
                     <h5>Contact Info</h5>
                     <ul>
                        <li><a href="mailto:firstlightadv@gmail.com"  target="_blank" rel="noreferrer"> firstlightadv@gmail.com</a> </li>
                        
                        {/* <li><a href="https://www.instagram.com/" target="_blank" className="foot_instagram" rel="noreferrer"> </a> <a href="https://www.facebook.com/" target="_blank" className="foot_facebook" rel="noreferrer"> </a> </li> */}
                         </ul>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
};

export default Footer;







